import { Component, HostBinding, OnInit, inject } from '@angular/core';

import { Location } from '@angular/common';

import { ConfigFacade } from '@library/store/config/config.facade';
import { CallbackService } from '@library/utils/services/callback.service';
import { HeaderService } from '@library/utils/services/header.service';
import { UserAgentService } from '@library/utils/services/user-agent.service';

@Component({
  selector: 'lay-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})

/**
 * Displays a header at the top of the view
 */
export class HeaderComponent implements OnInit {
  private readonly location = inject(Location);
  agent = inject(UserAgentService);
  callback = inject(CallbackService);
  headerService = inject(HeaderService);
  configFacade = inject(ConfigFacade);

  /**
   * Text to show in the Header
   */
  public title: string;

  /**
   * Display the back button
   */
  public needBack: boolean;

  /**
   * Display the close button
   */
  public needClose = false;

  @HostBinding('class.webapp-mode') webappMode = this.configFacade.getWebappMode();

  ngOnInit() {
    this.headerService.header$.subscribe(header => {
      this.title = header.title;
      this.needBack = header.needBack;
      this.needClose = header.needClose;
    });
  }

  /**
     * Called upon clinking the back button
     * Go back in the history or call the back function if provided
     */
  back(): void {
    this.location.back();
  }

  close(): void {
    this.callback.call(this.callback.list.shouldExit);
  }
}
